import {
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import Header from "../../components/Header";
import ConcreteReport from "../concreteReport/ConcreteReport";
import { Cancel, Close } from "@mui/icons-material";
import FieldDensityReport from "../fieldDensityReport/FieldDensityReport";
import InterlockPavingReport from "../interlockPavingReport/InterlockPavingReport";
import CementReport from "../cementReport/CementReport";
import ParticleSizeGravelFine from "../particleSizeGravel/ParticleSizeGravelFine";
import ZnAluminiumReport from "../znAluminiumReport/ZnAluminiumReport";
import ReboundHammerTest from "../hammerTest/ReboundHammerTest";
import MaterialGIPipesReport from "../materialGIPipesReport/MaterialGIPipesReport";
import HeightOfDrilledCore from "../coreCutterReport/HeightOfDrilledCore";
import ComStrengthDrilledCore from "../coreCutterReport/ComStrengthDrilledCore";
import CoarseAggrigate19mm from "../coarseAggrigate19mm/CoarseAggrigate19mm";
import CementBlocks from "../cementBlocks/CementBlocks";
import ProctorCompaction from "../proctorCompaction/ProctorCompaction";
const ReportTypeDialog = ({
  handleClose,
  open,
  data,
  selectedTest,
  loggedUser,
  setOpenReportDialog,
}) => {
  // console.log("This is report type dialog ", data);

  return (
    <div>
      <Dialog
        open={open}
        maxWidth="lg"
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Header
              title={"LAB TEST REPORT"}
              subtitle={"Enter test results."}
            />
            <Box display="flex" gap={2} alignItems="center">
              <Typography variant="h3" color="success">
                Job{" "}
                {data?.year + "/" + String(data?.autoIdByYear).padStart(4, "0")}
              </Typography>
              <IconButton aria-label="Close" onClick={handleClose}>
                <Close />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent>
          {selectedTest?.labTest.id === 21 ||
          selectedTest?.labTest.id === 22 ||
          selectedTest?.labTest.id === 58 ||
          selectedTest?.labTest.id === 59 ||
          selectedTest?.labTest.id === 60 ||
          selectedTest?.labTest.id === 61 ||
          selectedTest?.labTest.id === 62 ||
          selectedTest?.labTest.id === 64 ||
          selectedTest?.labTest.id === 65 ||
          selectedTest?.labTest.id === 63 ? ( //concrete report
            <ConcreteReport
              selectedTest={selectedTest}
              handleClose={handleClose}
              data={data}
              loggedUser={loggedUser}
              setOpenReportDialog={setOpenReportDialog}
            />
          ) : selectedTest?.labTest.id === 8 ? ( // field density repoort / compaction test
            <FieldDensityReport
              selectedTest={selectedTest}
              handleClose={handleClose}
              data={data}
              setOpenReportDialog={setOpenReportDialog}
            />
          ) : selectedTest?.labTest.id === 40 ? ( // interlock report
            <InterlockPavingReport
              selectedTest={selectedTest}
              handleClose={handleClose}
              data={data}
              setOpenReportDialog={setOpenReportDialog}
            />
          ) : selectedTest?.labTest.id === 46 ||
            selectedTest?.labTest.id === 45 ||
            selectedTest?.labTest.id === 57 ? ( // cement report
            <CementReport
              selectedTest={selectedTest}
              handleClose={handleClose}
              data={data}
              loggedUser={loggedUser}
              setOpenReportDialog={setOpenReportDialog}
            />
          ) : selectedTest?.labTest.id === 32 ||
            selectedTest?.labTest.id === 33 ||
            selectedTest?.labTest.id === 34 ||
            selectedTest?.labTest.id === 35 ||
            selectedTest?.labTest.id === 36 ||
            selectedTest?.labTest.id === 37 ||
            selectedTest?.labTest.id === 38 ||
            selectedTest?.labTest.id === 39 ||
            selectedTest?.labTest.id === 66 ||
            selectedTest?.labTest.id === 67 ||
            selectedTest?.labTest.id === 68 ? ( // particle size fine report
            <ParticleSizeGravelFine
              selectedTest={selectedTest}
              handleClose={handleClose}
              data={data}
              loggedUser={loggedUser}
              setOpenReportDialog={setOpenReportDialog}
            />
          ) : selectedTest?.labTest.id === 23 ? ( // Hammer
            <ReboundHammerTest
              selectedTest={selectedTest}
              handleClose={handleClose}
              data={data}
              loggedUser={loggedUser}
              setOpenReportDialog={setOpenReportDialog}
            />
          ) : selectedTest?.labTest.id === 55 ||
            selectedTest?.labTest.id === 80 ||
            selectedTest?.labTest.id === 74 ||
            selectedTest?.labTest.id === 75 ||
            selectedTest?.labTest.id === 77 ||
            selectedTest?.labTest.id === 73 ? ( // particle size fine report
            <ZnAluminiumReport
              selectedTest={selectedTest}
              handleClose={handleClose}
              data={data}
              loggedUser={loggedUser}
              setOpenReportDialog={setOpenReportDialog}
            />
          ) : selectedTest?.labTest.id === 81 ||
            selectedTest?.labTest.id === 54 ? ( // Material Testing
            <MaterialGIPipesReport
              selectedTest={selectedTest}
              handleClose={handleClose}
              data={data}
              loggedUser={loggedUser}
              setOpenReportDialog={setOpenReportDialog}
            />
          ) : selectedTest?.labTest.id === 27 ? ( // Core drilling test
            <HeightOfDrilledCore
              selectedTest={selectedTest}
              handleClose={handleClose}
              data={data}
              loggedUser={loggedUser}
              setOpenReportDialog={setOpenReportDialog}
            />
          ) : selectedTest?.labTest.id === 28 ? ( // Core drilling strength test
            <ComStrengthDrilledCore
              selectedTest={selectedTest}
              handleClose={handleClose}
              data={data}
              loggedUser={loggedUser}
              setOpenReportDialog={setOpenReportDialog}
            />
          ) : selectedTest?.labTest.id === 3 ? ( // coarse aggrigate test
            <CoarseAggrigate19mm
              selectedTest={selectedTest}
              handleClose={handleClose}
              data={data}
              loggedUser={loggedUser}
              setOpenReportDialog={setOpenReportDialog}
            />
          ) : selectedTest?.labTest.id === 41 ||
            selectedTest?.labTest.id === 42 ? ( // cement block
            <CementBlocks
              selectedTest={selectedTest}
              handleClose={handleClose}
              data={data}
              loggedUser={loggedUser}
              setOpenReportDialog={setOpenReportDialog}
            />
          ) : selectedTest?.labTest.id === 10 ? ( // standard Proctor compaction
            <ProctorCompaction
              selectedTest={selectedTest}
              handleClose={handleClose}
              data={data}
              loggedUser={loggedUser}
              setOpenReportDialog={setOpenReportDialog}
            />
          ) : (
            ""
          )}
        </DialogContent>
        <Divider />
        <DialogActions sx={{ paddingRight: "25px" }}></DialogActions>
      </Dialog>
    </div>
  );
};

export default ReportTypeDialog;
